import { IconButton } from '../components';

export function isFavoriteIcon() {
  return typeof window.functionId !== 'undefined' || !!window.helpUrl;
}

export const FavoriteIcon = () => {
  return <IconButton icon="Star" />;
};
